define('vspot-angular/resources/school-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // See user-resource for general documentation
        return $resource('/api/schools/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                /*
                 *  Gets a list of all schools within a certain
                 *  area, based on zip code.
                 *
                 *  @param  zipcode - A five digit number
                 *  @param  radius  - A number, measured in miles
                 *
                 *  @returns  Resource object. See /resources.js documentation for details
                 *            Expected return data: { status: boolean,
                 *                                    zips: array_of_zips,
                 *                                    num_of_zips: array_of_zips.size,
                 *                                    num_of_schools: array_of_schools.size,
                 *                                    schools: array_of_schools }
                 */
                query: {
                    method:     'GET',
                    isArray:    false,
                    cache:      false
                }
            }
        );
    }];
});

